/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import Button from '@material-ui/core/Button';
import { Grid, MenuItem } from '@material-ui/core';
import { BreakPointToMobile } from '../Helpers/Helper';
import DesktopMobile from '../../../../../../helpers/DesktopMobile/DesktopMobile';
import { getCountryCodeFromTwoToThreeDigit } from '../../../../../../../state/ducks/Checkout/helpers/countryCode';
import MaskInput from '../TextFieldWrapper/MaskInput';

const getPages = (start, end) => new Array(end - start).fill().map((d, i) => i + start);

export const getPaginationLinks = (classes, pageOn, totalPages, handlePageChange) => {
    const arrPages = getPages(0, totalPages);
    return arrPages.map((item) => {
        if (pageOn === item) {
            return (
                <Button
                    key={`page${item + 1}`}
                    id={`page${item + 1}`}
                    data-test={`page-address-book-${item + 1}`}
                    classes={{
                        root: classes.pageLinkSelected,
                    }}
                    link="#"
                    disableRipple
                >
                    {item + 1}
                </Button>
            );
        }

        return (
            <Button
                id={`page${item + 1}`}
                data-test={`page-address-book-${item + 1}`}
                classes={{
                    root: classes.pageLink,
                }}
                onClick={() => { handlePageChange(item); }}
                disableRipple
            >
                {item + 1}
            </Button>
        );
    });
};

export const addressBookComponentList = (
    classes, entries, pageOn, totalPages, handleRemoveAddressBook, handleEditAddressBook,
    handleUseThisAddress, itemCountriesProdDeliverable = [], relationshipList, lineItemType,
    productBrandId,
) => {
    const componentList = [];

    if (entries?.length > 0) {
        entries.forEach((addressInfo) => {
            const addressBook = addressInfo.addresses[0] || [];
            let country = addressBook.country || 'USA';
            addressBook.phoneNumber = addressInfo?.rcpPhone || '';

            if (country.length !== 3) {
                country = getCountryCodeFromTwoToThreeDigit(country) || country;
            }

            const isCountryUSAorCanada = ['US', 'USA', 'CA', 'CAN'].includes(country);

            // We dont show this for international or
            // If the product can't be deliverable in canada we dont show canada countries
            if (
                !isCountryUSAorCanada
                || !itemCountriesProdDeliverable?.includes(country)
                || (
                    (
                        lineItemType === 'GREETINGCARD-ITEM'
                        || productBrandId === '1036'
                    )
                    && !['Residence', 'Business'].includes(addressBook.addressType))
            ) {
                return null;
            }

            let addressType = '';
            if (addressBook.employerName && addressBook.addressType) {
                addressType = `${addressBook.addressType} ${addressBook.employerName}, `;
            }

            let relationShip = '';
            if (addressBook.relationship && relationshipList && relationshipList[addressBook.relationship]) {
                relationShip = relationshipList[addressBook.relationship];
            }

            let phone = addressBook?.phoneNumber || '';
            if (addressBook?.phoneNumber) {
                const maskInputFun = MaskInput.Phone;
                const resMaskInput = maskInputFun(addressBook.phoneNumber);
                if (resMaskInput) {
                    phone = resMaskInput.maskInputVal;
                }
            }

            componentList.push(
                <Grid key={`addressList${addressBook.addressBookEntryId}`} container className={classes.addressItemContent}>
                    <Grid container className={classes.listAddresses} alignItems="stretch">
                        <Grid className={classes.leftList} item xs={12} md={1} lg={1}>
                            <span>{addressBook.firstName?.[0] || ' '}{addressBook.lastName?.[0] || ''}</span>
                        </Grid>
                        <Grid className={classes.rightList} item xs={12} md={11} lg={11}>
                            <Grid container>
                                <Grid item xs={12} md={8} lg={8}>
                                    <Grid container>
                                        <p className={classes.infoText}>
                                            <strong className={classes.title}>{addressBook.firstName || ''} {addressBook.lastName || ''}{relationShip ? `, ${relationShip}` : ''}: </strong>
                                            {addressType}{addressBook.addressLineOne || ''}, {addressBook.addressLineTwo ? ` ${addressBook.addressLineTwo},` : ''} {addressBook.city || ''}, {addressBook.state || ''} {addressBook.zip || ''}, {addressBook.country || ''}{phone ? <>, <span className={classes.phoneInfo}>{phone}</span></> : ''}
                                        </p>
                                    </Grid>
                                    <DesktopMobile
                                        breakpoint={BreakPointToMobile}
                                        desktop={() => (
                                            <Grid container>
                                                <Button
                                                    key={`checkout-addres-book-shipment-${addressBook.addressBookEntryId}`}
                                                    data-test="checkout-addres-book-shipment-savedAddress"
                                                    classes={{
                                                        root: classes.btnUseAddress,
                                                    }}
                                                    onClick={() => handleUseThisAddress(addressBook)}
                                                >
                                                    Use This Address
                                                </Button>
                                            </Grid>
                                        )}
                                        mobile={() => null}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4} lg={4}>
                                    <Grid container className={classes.contEditRemove}>
                                        <DesktopMobile
                                            breakpoint={BreakPointToMobile}
                                            desktop={() => null}
                                            mobile={() => (
                                                <Grid item xs={7} md={12} lg={12}>
                                                    <Button
                                                        key={`checkout-addres-book-shipment-${addressBook.addressBookEntryId}`}
                                                        data-test="checkout-addres-book-shipment-savedAddress"
                                                        classes={{
                                                            root: classes.btnUseAddress,
                                                        }}
                                                        onClick={() => handleUseThisAddress(addressBook)}
                                                    >
                                                        Use This Address
                                                    </Button>
                                                </Grid>
                                            )}
                                        />
                                        <Grid item xs={5} md={12} lg={12}>
                                            <Grid container className={classes.contButtons} justifyContent="flex-end">
                                                <Button
                                                    key={`checkout-address-book-edit-${addressBook.addressBookEntryId}`}
                                                    data-test="checkout-address-book-edit-savedAddress"
                                                    classes={{
                                                        root: classes.btnEditDelete,
                                                    }}
                                                    value={addressBook.addressBookEntryId}
                                                    onClick={() => handleEditAddressBook(addressBook)}
                                                    disableRipple
                                                >
                                                    Edit
                                                </Button>
                                                {' | '}
                                                <Button
                                                    key={`checkout-address-book-deelete-${addressBook.addressBookEntryId}`}
                                                    data-test="checkout-address-book-delete-savedAddress"
                                                    classes={{
                                                        root: classes.btnEditDelete,
                                                    }}
                                                    value={addressBook.addressBookEntryId}
                                                    onClick={() => handleRemoveAddressBook(addressBook.addressBookEntryId)}
                                                    disableRipple
                                                >
                                                    Delete
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>,
            );

            return null;
        });

        return componentList;
    }
    return (
        <MenuItem classes={{ root: classes.menuRootClass }}>
            {
                totalPages > 1
                    ? `Address not found in page ${pageOn + 1}`
                    : ''
            }
        </MenuItem>
    );
};

export default {};
